// src/components/Image.jsx
import React from "react";

/**
 * A reusable Image component with fallback error handling.
 * @param {Object} props
 * @param {string} props.src - The image source URL.
 * @param {string} props.alt - The alt text for the image.
 * @param {string} [props.className=""] - Additional CSS classes.
 * @param {Object} props - Other props to pass to the img element.
 */
const Image = ({ src, alt, className = "", ...props }) => {
  const FALLBACK_IMAGE = "/zoomo-mascot.png";

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      onError={(e) => (e.target.src = FALLBACK_IMAGE)}
      loading="lazy"
      {...props}
    />
  );
};

export default Image;